import { put, all, takeLatest, select } from "redux-saga/effects";
import * as actionTypes from "./actionTypes";
import API from "../../commonUtils/API.js";
import { toast } from "react-toastify";
import { handleApiError } from "../../commonUtils/Functions";

function* getDataCategoriesSaga({ params }) {
    const { currentPage, perPage } = params;

    try {
        yield put({ type: actionTypes.SET_LOADING, payload: true });

        const filters = yield select((state) => state.DataCategories.filters);

        let queryString = `currentPage=${currentPage}&perPage=${perPage}`;
        if(filters.keyword) queryString = queryString.concat(`&keyword=${encodeURIComponent(filters.keyword)}`);

        const { data } = yield API.get(`/data-categories?${queryString}`);
        if (data.success) {
            yield put({ type: actionTypes.GET_DATA_CATEGORIES_SUCCESS, payload: data.data });
        } else {
            toast.error("Oops! Something went unexpectedly wrong.");
            yield put({ type: actionTypes.GET_DATA_CATEGORIES_FAILURE, payload: data });
        }

    } catch (error) {
        handleApiError(error, "Oops! Something went unexpectedly wrong.");
        const data = error?.response?.data;
        yield put({ type: actionTypes.GET_DATA_CATEGORIES_FAILURE, payload: data || { message: "Internal server error" } });
    }
};

function* createDataCategorySaga({ payload }) {
    try {
        yield put({ type: actionTypes.SET_LOADING, payload: true });
        const { formData } = payload;
        const { data } = yield API.post("/data-categories", formData);
        if (data.success) {
            yield put({ type: actionTypes.CREATE_DATA_CATEGORY_SUCCESS, payload: data.data });
            yield put({ type: actionTypes.GET_DATA_CATEGORIES, params: {} });
        } else {
            toast.error(data?.message || "Could not save data category.");
            yield put({ type: actionTypes.CREATE_DATA_CATEGORY_FAILURE, payload: data });
        }

    } catch (error) {
        handleApiError(error, "Could not save data category.");
        const data = error?.response?.data;
        yield put({ type: actionTypes.CREATE_DATA_CATEGORY_FAILURE, payload: data || { message: "Internal server error" } });
    }
};

function* updateDataCategorySaga({ payload }) {
    try {
        yield put({ type: actionTypes.SET_LOADING, payload: true });
        const { id, formData } = payload;
        const { data } = yield API.put(`/data-categories/${id}`, formData);
        if (data.success) {
            const { pagination } = yield select((state) => state.DataCategories.DataCategoriesList);
            const params = { currentPage: pagination.currentPage, perPage: pagination.perPage };
            yield put({ type: actionTypes.UPDATE_DATA_CATEGORY_SUCCESS, payload: data.data });
            yield put({ type: actionTypes.GET_DATA_CATEGORIES, params });
        } else {
            toast.error(data?.message || "Could not save updated data category data.");
            yield put({ type: actionTypes.UPDATE_DATA_CATEGORY_FAILURE, payload: data });
        }

    } catch (error) {
        handleApiError(error, "Could not save updated data category data.");
        const data = error?.response?.data;
        yield put({ type: actionTypes.UPDATE_DATA_CATEGORY_FAILURE, payload: data || { message: "Internal server error" } });
    }
}

function* updateDataCategoryStatusSaga({ Id }) {
    try {
        yield put({ type: actionTypes.SET_LOADING, payload: true });

        const { data } = yield API.patch(`/data-categories/${Id}/status`);

        if (data.success) {
            const { pagination } = yield select((state) => state.DataCategories.DataCategoriesList);
            const params = { currentPage: pagination.currentPage, perPage: pagination.perPage };
            yield put({ type: actionTypes.UPDATE_DATA_CATEGORY_STATUS_SUCCESS, payload: data.data });
            yield put({ type: actionTypes.GET_DATA_CATEGORIES, params });
        } else {
            toast.error(data?.message || "Could not update data category status.");
            yield put({ type: actionTypes.UPDATE_DATA_CATEGORY_STATUS_FAILURE, payload: data });
        }

    } catch (error) {
        handleApiError(error, "Could not update data category status.");
        const data = error?.response?.data;
        yield put({ type: actionTypes.CREATE_DATA_CATEGORY_FAILURE, payload: data || { message: "Internal server error" } });
    }
};

function* deleteDataCategorySaga({ Id }) {
    try {
        yield put({ type: actionTypes.SET_LOADING, payload: true });

        const { data } = yield API.delete(`/data-categories/${Id}`);

        if (data.success) {
            const { pagination } = yield select((state) => state.DataCategories.DataCategoriesList);
            const params = { currentPage: pagination.currentPage, perPage: pagination.perPage };
            yield put({ type: actionTypes.DELETE_DATA_CATEGORY_SUCCESS, payload: data.data });
            yield put({ type: actionTypes.GET_DATA_CATEGORIES, params });
        } else {
            toast.error(data?.message || "Could not delete data category.");
            yield put({ type: actionTypes.DELETE_DATA_CATEGORY_FAILURE, payload: data });
        }

    } catch (error) {
        handleApiError(error, "Could not delete data category.");
        const data = error?.response?.data;
        toast.error(data?.message || "Could not delete data category.");
        yield put({ type: actionTypes.CREATE_DATA_CATEGORY_FAILURE, payload: data || { message: "Internal server error" } });
    }
};


function* DataCategoriesSaga() {
  yield all([
    takeLatest(actionTypes.GET_DATA_CATEGORIES, getDataCategoriesSaga),
    takeLatest(actionTypes.CREATE_DATA_CATEGORY, createDataCategorySaga),
    takeLatest(actionTypes.UPDATE_DATA_CATEGORY, updateDataCategorySaga),
    takeLatest(actionTypes.UPDATE_DATA_CATEGORY_STATUS, updateDataCategoryStatusSaga),
    takeLatest(actionTypes.DELETE_DATA_CATEGORY, deleteDataCategorySaga),
  ]);
}

export default DataCategoriesSaga;
